import { selectEntitiesMatchesEntityStatus } from '../../../../selectors/entities/matches/entitiesMatchesPrimary.selector';
import { MatchStatuses, type MatchStatus } from '../../../../types/match';
import { type Selector } from '../../../../types/selectors';
import { createResultEqualSelector } from '../../../../utils/reselect';

type LineUpRaceStatusIndicatorPropsType = {
  matchStatus: MatchStatus;
};

const selectLineUpRaceStatusIndicatorProps: Selector<LineUpRaceStatusIndicatorPropsType> = createResultEqualSelector(
  [selectEntitiesMatchesEntityStatus],
  (matchStatus) => ({
    matchStatus: matchStatus ?? MatchStatuses.PREMATCH,
  }),
);

export default selectLineUpRaceStatusIndicatorProps;
